import React from 'react';
import Slider from "react-slick";
import slidImg1 from "../../../assets/images/home/slider/Slide.jpg";
import slidImg2 from "../../../assets/images/home/slider/Slide-2.jpg";
import slidImg3 from "../../../assets/images/home/slider/Slide-3.jpg";
import { useGetSlidersQuery } from '../../../features/api/apiSlice';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';

const SliderHad = () => {
    const { data: slidrs, isLoading, isError } = useGetSlidersQuery();
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    const settings = {
        // dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        // cssEase: "linear"
    };


    let content = null;
    if (isLoading) {
        content = (
            <Slider {...settings}>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg1} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg2} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg3} alt="img" />
                </div>
            </Slider>
        )
    }
    if (!isLoading && isError) {
        content = (
            <Slider {...settings}>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg1} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg2} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg3} alt="img" />
                </div>
            </Slider>

        )
    }
    if (!isLoading && !isError && slidrs?.length === 0) {
        content = (
            <Slider {...settings}>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg1} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg2} alt="img" />
                </div>
                <div>
                    <img className='w-full h-full object-fill' src={slidImg3} alt="img" />
                </div>
            </Slider>

        )
    }
    if (!isLoading && !isError && slidrs?.length > 0) {

        content = (
            <Slider {...settings}>
                {slidrs.map((slide, index) => (
                    <div key={index}>
                        {slide?.link === '' ?
                            <img className='w-full h-full object-fill' src={slide?.img} alt="img" />
                            :
                            <Link to={`/products/${slide?.link}`} >
                                <img className='w-full h-full object-fill' src={slide?.img} alt="img" />
                            </Link>
                        }
                    </div>
                ))}
            </Slider>

        )
    }


    return (
        <div className='c_h_slider'>
            <div className='relative md:-top-0 -top-2'>
                {content}
                <div className='bg-bnd-2 marquee-div font-normal text-white m-0 p-0 h-6'>
                    <marquee>{translate ?
                        'Welcome to our website and see a world of difference through the fragrant perfumes we produce!'
                        :
                        'আমাদের ওয়েবসাইটে স্বাগতম। আমরা যে সুগন্ধি পারফিউম তৈরি করি তার মাধ্যমে পার্থক্যের একটি বিশ্ব দেখুন!'
                    } </marquee>
                </div>
            </div>

        </div>
    );
};

export default SliderHad;